import moment from "moment";
import { FunctionComponent, SyntheticEvent, useCallback, useEffect, useMemo, useState } from "react";
import { PrimaryButton } from "../../components/button";
import { Icon } from "../../components/icons";
import { Table } from "../../components/table";
import { TableHeaders } from "../../components/table/Head";
import { Widget } from "../../components/widget";

import { ApiDocument, ApiDocumentEmailContent, ApiDocumentEmailPagable, KycFile, KycTypedFile, useDocumentsEmailMutation, useDocumentsHistoryQuery, useKycDocumentsEmailsQuery } from "../../store/models/risk";
import { NullablePartial } from "../../utils/utils";
import { UsersDTO } from "../../store/users/models/dto";
import { processErrorFromPromise } from "../../store/errors/utils";
import { successNotificationFromPromise } from "../../store/notifications/utils";
import { API } from "../../services/http";
import { VerificationService } from "../../store/verification/service";

// type fieldNames = keyof KycTypedFile;
// type RequestDTO = UsersDTO.Requests.UserDetails.T;
function useHeaders(): TableHeaders<any> {

    return useMemo(
        () => [
            // {
            //     name: "id",
            //     title: "Id",
            // },
            {
                name: "sent",
                title: "Sent On",
            },
            {
                name: "recipientName",
                title: "Name",
            },

            {
                name: "recipientEmailAddress",
                title: "Email",
            },
            {
                name: "selfie",
                title: "Selfie",
            },
            {
                name: "identity",
                title: "Identity",
            },
            {
                name: "proofOfAddress",
                title: "Proof of Address",
            },
            // {
            //     name: "skrtCertificate",
            //     title: "SKRT Certificate",
            // },
            // {
            //     name: "id",
            //     title: "Actions",
            // },

        ],
        []
    );
}

export const PreviousKycPacks: FunctionComponent<{
}> = ({
}) => {
        const headers = useHeaders();
        const [size, setSize] = useState<number>(15);
        const [page, setPage] = useState<number>(0);
        const [disableButton, setDisableButton] = useState<boolean>(false);


        const { data: history } = useKycDocumentsEmailsQuery(
            {
                page: page,
                size: size
            },
            { refetchOnMountOrArgChange: true }
        );

        const onDownload = (id: string, fileName: string) => {
            VerificationService.downloadKycDocumentById({
                docId: id,
                fileName,
            });
        }

        // const [sendDocuments] = useDocumentsEmailMutation();

        return (
            <Widget title="My KYC Documents History">
                {/* {JSON.stringify(history)} */}
                {history &&
                    <Table
                        data={history.content}
                        head={headers}
                        pagination={history.pageable}
                        onPaginationChange={(x: any) => {
                            setSize(x.pagination.size);
                            setPage(x.pagination.page);
                        }}
                        pageableState={{
                            // sorting: {
                            //     direction: "asc",
                            //     field: "sent",
                            // },
                            pagination: {
                                page: page,
                                size: size,
                            },
                        }}
                        renderFields={{

                            sent: ({ sent }) => (
                                <>{moment(sent).local().format("yyyy-MM-DD HH:mm")}</>
                            ),

                            selfie: ({ documents }) => (
                                <>
                                    {documents.some(x => x.category === 'FACE') &&
                                        <PrimaryButton fullWidth
                                            disabled={disableButton}
                                            onClick={() => {
                                                onDownload(documents.find(x => x.category === 'FACE')?.id as string, documents.find(x => x.category === 'FACE')?.filename as string);
                                            }}>
                                            <Icon type="download" />
                                        </PrimaryButton>
                                    }
                                </>
                            ),
                            identity: ({ documents }) => (
                                <>
                                    {documents.some(x => x.category === 'IDENTITY') &&
                                        <PrimaryButton fullWidth
                                            disabled={disableButton}
                                            onClick={() => {
                                                onDownload(documents.find(x => x.category === 'IDENTITY')?.id as string, documents.find(x => x.category === 'IDENTITY')?.filename as string);
                                            }}>
                                            <Icon type="download" />
                                        </PrimaryButton>}
                                </>
                            ),
                            proofOfAddress: ({ documents }) => (
                                <>
                                    {documents.some(x => x.category === 'ADDRESS') &&
                                        <PrimaryButton fullWidth
                                            disabled={disableButton}
                                            onClick={() => {
                                                onDownload(documents.find(x => x.category === 'ADDRESS')?.id as string, documents.find(x => x.category === 'ADDRESS')?.filename as string);
                                            }}>
                                            <Icon type="download" />
                                        </PrimaryButton>
                                    }
                                </>
                            ),
                            // skrtCertificate: ({ documents }) => (
                            //     <>

                            //     </>
                            // ),
                            // id: ({ id }) => (
                            //     <>

                            //     </>
                            // )
                        }}
                    // unsortable={["id", "sent", "recipientName", "recipientEmailAddress", "documents"]}

                    />
                }
            </Widget>
        );
    };
